var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_12283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.376 9.93551C12.2268 9.40134 11.9418 8.89717 11.5218 8.47801C10.2202 7.17634 8.10933 7.17551 6.80766 8.47801L2.64266 12.643C1.341 13.9455 1.34016 16.0555 2.64266 17.3572C3.94433 18.6597 6.056 18.658 7.356 17.3572L10.5577 14.1563L10.8352 14.1638C11.1718 14.1638 11.5035 14.1305 11.826 14.0663L7.94516 17.9463C7.13266 18.7597 6.066 19.1663 4.99933 19.1663C3.93266 19.1663 2.866 18.7597 2.0535 17.9463C0.426829 16.3205 0.426829 13.6797 2.0535 12.0538L6.2185 7.88884C7.031 7.07551 8.0985 6.66884 9.16516 6.66884C10.231 6.66884 11.2985 7.07551 12.111 7.88884C12.5218 8.29967 12.8285 8.77467 13.0318 9.28218L12.376 9.93551ZM7.6235 10.058C7.77183 10.5938 8.05766 11.0997 8.4785 11.5213C9.78016 12.8238 11.8918 12.8222 13.1918 11.5213L17.3577 7.35634C18.6602 6.05467 18.6602 3.94384 17.3577 2.64217C16.056 1.34051 13.9452 1.33967 12.6435 2.64217L9.44266 5.84301L9.16516 5.83551C8.8285 5.83551 8.49683 5.86884 8.17433 5.93301L12.0543 2.05301C12.8668 1.23967 13.9343 0.833008 15.001 0.833008C16.0668 0.833008 17.1343 1.23967 17.9468 2.05301C19.5727 3.67884 19.5727 6.31884 17.9468 7.94551L13.781 12.1105C12.9685 12.9238 11.9018 13.3305 10.8352 13.3305C9.7685 13.3305 8.70183 12.9238 7.88933 12.1105C7.47766 11.698 7.17016 11.2213 6.96683 10.7122L7.6235 10.058Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_12283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic_link.c89e1f601f347d3a14e4d9857311874e.svg";
export { ForwardRef as ReactComponent };